/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RealEstateDto } from './RealEstateDto';
import {
    RealEstateDtoFromJSON,
    RealEstateDtoFromJSONTyped,
    RealEstateDtoToJSON,
    RealEstateDtoToJSONTyped,
} from './RealEstateDto';
import type { PersonDto } from './PersonDto';
import {
    PersonDtoFromJSON,
    PersonDtoFromJSONTyped,
    PersonDtoToJSON,
    PersonDtoToJSONTyped,
} from './PersonDto';

/**
 * 
 * @export
 * @interface GetUpiRiskResponse
 */
export interface GetUpiRiskResponse {
    /**
     * 
     * @type {string}
     * @memberof GetUpiRiskResponse
     */
    type: string;
    /**
     * 
     * @type {PersonDto}
     * @memberof GetUpiRiskResponse
     */
    person?: PersonDto;
    /**
     * 
     * @type {RealEstateDto}
     * @memberof GetUpiRiskResponse
     */
    realEstate?: RealEstateDto;
}

/**
 * Check if a given object implements the GetUpiRiskResponse interface.
 */
export function instanceOfGetUpiRiskResponse(value: object): value is GetUpiRiskResponse {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GetUpiRiskResponseFromJSON(json: any): GetUpiRiskResponse {
    return GetUpiRiskResponseFromJSONTyped(json, false);
}

export function GetUpiRiskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUpiRiskResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'person': json['person'] == null ? undefined : PersonDtoFromJSON(json['person']),
        'realEstate': json['realEstate'] == null ? undefined : RealEstateDtoFromJSON(json['realEstate']),
    };
}

export function GetUpiRiskResponseToJSON(json: any): GetUpiRiskResponse {
    return GetUpiRiskResponseToJSONTyped(json, false);
}

export function GetUpiRiskResponseToJSONTyped(value?: GetUpiRiskResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'person': PersonDtoToJSON(value['person']),
        'realEstate': RealEstateDtoToJSON(value['realEstate']),
    };
}

